import styled from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const NumberFormatted = styled(NumberFormat)(
  ({ width, height }) => `
  width: ${width ? `${width}px` : '100%'};
  height: ${height || '58'}px;
  font-size: 16px;
  padding: 10px 16px;
  font-family: UbuntuRegular;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3f4957;
  border-radius: 4px;

  &.has-error {
    border-color: #dc3545;
    box-shadow: 0 0 8px 1px rgba(220, 53, 69, 0.08);
  }

  @media (max-width: 767.98px) {
    font-size: 14px;
  }

  ::placeholder {
    color: #6b7789;
  }

  :focus {
    border-color: #0d6efd;
    box-shadow: 0 0 8px 1px rgba(22, 32, 86, 0.08);
  }

  :hover {
    border-color: #0d6efd;
  }
`,
);

const CustomMoneyInputDaily = ({ onChange, record, value = 0, disable = false, setDisable = () => {}, placeholder = '', className = '', ...props }) => {
  const [internalValue, setInternalValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const handleValueChange = ({ floatValue, formattedValue }) => {
    const newValue = formattedValue === '' ? 0 : floatValue;
    setInternalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
    if (internalValue === 0) {
      setInternalValue('');
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (internalValue === '') {
      setInternalValue(0);
    }
  };

  return (
    <NumberFormatted
      tabIndex={0}
      allowNegative={false}
      precision={2}
      fixedDecimalScale={true}
      className={`ant-input ${className}`}
      value={isFocused && internalValue === 0 ? '' : internalValue}
      decimalScale={2}
      thousandSeparator="."
      decimalSeparator=","
      disabled={disable}
      onValueChange={handleValueChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      getInputRef={(el) => (inputRef.current = el)}
      placeholder={isFocused && internalValue === '' ? placeholder : ''}
      {...props}
    />
  );
};

CustomMoneyInputDaily.propTypes = {
  onChange: PropTypes.func,
  record: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disable: PropTypes.bool,
  setDisable: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default CustomMoneyInputDaily;
